<template>
    <section class="publications-list-container">
        <Loading v-if="loading" />
        <ul
            class="publications-list block-list"
            v-if="!loading && list.length > 0"
        >
            <PublicationItem
                v-for="(value, index) in list"
                :key="'pubitem-' + index"
                :data="value"
            />
        </ul>
        <div class="no-posts-found" v-if="!loading && list.length == 0">
            <p>
                No posts were found that match your search and/or filters.
            </p>
            <p>
                Please try another request.
            </p>
        </div>
    </section>
</template>

<script>
import PublicationItem from '@/components/PublicationItem.vue';
import Loading from '@/components/Loading';

export default {
    components: {
        PublicationItem,
        Loading,
    },
    computed: {
        list() {
            return this.$store.getters.list;
        },
        loading() {
            return this.$store.getters.loading('list');
        },
    },
    beforeMount() {
        this.$store.dispatch('getList', {
            isPageChange: false,
        });
    },
};
</script>

<style lang="scss" scoped>
#loading {
    display: block;
    margin: 40px auto;
}

.publications-list {
    padding: 0;
}
</style>
